/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type DevelopmentEnquiry_development$ref = any;
type lotPricePerMeterSquared_product$ref = any;
type lotPrice_product$ref = any;
export type DevelopmentRegistrationType = "complete_registration" | "normal_enquiry";
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentActionCard_development$ref: FragmentReference;
declare export opaque type DevelopmentActionCard_development$fragmentType: DevelopmentActionCard_development$ref;
export type DevelopmentActionCard_development = {|
  +id: string,
  +currentUserRegistrationForm: ?{|
    +id: string,
    +completed: boolean,
  |},
  +registrationType: DevelopmentRegistrationType,
  +products: $ReadOnlyArray<{|
    +salePrice: ?number,
    +$fragmentRefs: lotPrice_product$ref & lotPricePerMeterSquared_product$ref,
  |}>,
  +$fragmentRefs: DevelopmentEnquiry_development$ref,
  +$refType: DevelopmentActionCard_development$ref,
|};
export type DevelopmentActionCard_development$data = DevelopmentActionCard_development;
export type DevelopmentActionCard_development$key = {
  +$data?: DevelopmentActionCard_development$data,
  +$fragmentRefs: DevelopmentActionCard_development$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentActionCard_development",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "DevelopmentRegistrationForm",
      "kind": "LinkedField",
      "name": "currentUserRegistrationForm",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "completed",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registrationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "products",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salePrice",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "lotPrice_product"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "lotPricePerMeterSquared_product"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentEnquiry_development"
    }
  ],
  "type": "DevelopmentProduct",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '7f171881b352264d49b7b58a9f6d25c2';

export default node;
